<template>
	<Accordion.Root
		class="accordion-root"
		:multiple="multiple"
		:collapsible="collapsible"
		:default-value="persistedDefaultValue"
		@value-change="handleValueChange"
	>
		<slot />
	</Accordion.Root>
</template>

<script setup lang="ts">
import { Accordion } from "@ark-ui/vue"
import { computed } from "vue"

const props = withDefaults(
	defineProps<{
		multiple?: boolean
		collapsible?: boolean
		defaultValue?: string[]
		persistenceKey?: string
	}>(),
	{
		multiple: false,
		defaultValue: () => [],
		collapsible: true,
		persistenceKey: "accordion-state",
	}
)

const emit = defineEmits<{
	change: [value: string[]]
}>()

const getPersistedState = (): string[] => {
	try {
		const saved = localStorage.getItem(props.persistenceKey)
		return saved ? JSON.parse(saved) : props.defaultValue
	} catch (error) {
		console.warn("error:", error)
		return props.defaultValue
	}
}

const savePersistedState = (value: string[]) => {
	try {
		localStorage.setItem(props.persistenceKey, JSON.stringify(value))
	} catch (error) {
		console.warn("error:", error)
	}
}

const persistedDefaultValue = computed(() => getPersistedState())

const handleValueChange = (accordionChangeEvent: { value: string[] }) => {
	const newValue = accordionChangeEvent?.value ?? []

	savePersistedState(newValue)

	emit("change", newValue)
}
</script>

<style scoped>
.accordion-root {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);
	width: 100%;
}
</style>
